import React, { useState } from "react";
import { useObserver } from "mobx-react-lite";
import { Box } from "@material-ui/core";
import { BaseModal } from "Components/Modal/BaseModal";
import { CancelButton } from "Globals/Styles/Control/Buttons";
import { useRouter } from "@shoothill/core";
import styled from "styled-components";
import { ReportModalStyle } from "Views/Project/Modals/Modal.Styles";
import { NonConformanceListModel } from "./NonConformanceListModel";
import { formatDate, formatTime } from "Utils/Format";
import { SHBox } from "Components/Box";
import MaterialTable from "material-table";
import { PatchedPagination } from "Components/Table/PatchedPagination";
import * as Defaults from "../../../../../Globals/Defaults/TableOptions";
import { NonConformanceListViewModel } from "./NonConformanceListViewModel";

interface ICreatedModalProps {
    open?: boolean;
    onClose(): void;
    date: Date;
}

export const NonConformanceView: React.FC<ICreatedModalProps> = (props) => {
    const { match } = useRouter();
    const { projectid } = match.params as any;
    const { open, onClose, date } = props;
    const [listViewModel] = useState(() => new NonConformanceListViewModel(projectid, date));

    const COLUMNS8 = "1fr 1fr 1fr 1fr 1fr 1fr 1fr 1fr";
    const COLUMNS2 = "1fr 1fr";

    return useObserver(() => (
        <BaseModal
            open={open}
            onClose={onClose}
            title={"Non conformance"}
            PaperComponent={ReportModalStyle}
            actions={
                <>
                    <CancelButton onClick={onClose}>Cancel</CancelButton>
                </>
            }
        >
            <DelaysModel>
                <MaterialTable
                    columns={[
                        { title: "Conformance type", field: "nonConformanceTypeName" },
                        {
                            title: "Reference No.",
                            field: "nonConformanceNumber",
                            render: (rowData: NonConformanceListModel) => (
                                <SHBox>
                                    <SHBox>{`CDG-${listViewModel.referenceNumber(rowData.nonConformanceNumber)}`}</SHBox>
                                </SHBox>
                            ),
                        },
                        {
                            title: "Last updated",
                            field: "lastUpdatedDate",
                            render: (rowData: NonConformanceListModel) => (
                                <SHBox>
                                    <SHBox>
                                        {rowData.lastUpdatedDate !== "" ? formatDate(rowData.lastUpdatedDate) : "-"} @
                                        {rowData.lastUpdatedDate !== "" ? formatTime(rowData.lastUpdatedDate) : "-"}
                                    </SHBox>
                                    <SHBox>{rowData.lastUpdatedByUserName ? `by ${rowData.lastUpdatedByUserName} ` : ""}</SHBox>
                                </SHBox>
                            ),
                            defaultSort: "desc",
                        },
                    ]}
                    components={{
                        Pagination: PatchedPagination,
                    }}
                    options={Defaults.GetDarwinTableOptions()}
                    data={listViewModel.nonConformanceListItems}
                    onRowClick={(e, rowData) => {
                        listViewModel.handleRowClick(e, rowData!);
                    }}
                    title=""
                />
            </DelaysModel>
        </BaseModal>
    ));
};

const DelaysModel = styled(Box)`
    hr {
        background-color: transparent !important;
        border-top: 1px dashed rgba(206, 212, 218, 1) !important;
    }
`;
